/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LANGUAGE = 'app/LanguageProvider/CHANGE_LANGUAGE';
export const LOADING_LANGUAGE = 'app/LanguageProvider/LOADING_LANGUAGE';
export const LANGUAGE_LOADED = 'app/LanguageProvider/LANGUAGE_LOADED';
export const LOAD_UPPTACKA = 'app/LanguageProvider/LOAD_UPPTACKA';
export const COMMON_LOADED = 'app/LanguageProvider/COMMON_LOADED';
export const LANGUAGE_ERROR = 'app/LanguageProvider/LANGUAGE_ERROR';
export const LOADING_APPLICATION_SETTINGS = 'app/LanguageProvider/LOADING_APPLICATION_SETTINGS';
export const LOADING_PRODUCT_SERVICE = 'app/LanguageProvider/LOADING_PRODUCT_SERVICE';
export const LOADING_TRANSLATIONS = 'app/LanguageProvider/LOADING_TRANSLATIONS';
export const LOADING_SERVICE_SETTINGS = 'app/LanguageProvider/LOADING_SERVICE_SETTINGS';
export const LOADING_LOCALE = 'app/LanguageProvider/LOADING_LOCALE';
export const LOADING_DEXF_SETTINGS='app/LanguageProvider/LOADING_DEXF_SETTINGS';
export const LOADING_DATA_PROVIDER_SETTINGS = 'app/LanguageProvider/LOADING_DATA_PROVIDER_SETTINGS';
export const GLOBAL_COMMON_LOADED = 'app/LanguageProvider/GLOBAL_COMMON_LOADED';
